import { ILogger } from './ILogger';

declare const ROLLBAR_TOKEN: string;
declare const STAGE: string;

const rollbarConfig = {
	accessToken: ROLLBAR_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: window.rollbarIgnore,
	payload: {
		environment: STAGE
	}
};

const windowRollbar = window &&
window['rollbar'] &&
window['rollbarIgnore']
	? new window.rollbar(rollbarConfig)
	: undefined;

class Logger implements ILogger {
	public constructor(private rollbar?: Rollbar) { }

	public logError(reason: string, payload?: any): void {
		this.rollbar?.error(reason, JSON.stringify(payload));
	}

	public logWarning(reason: string, payload?: any): void {
		this.rollbar?.warn(reason, JSON.stringify(payload));
	}
}

export default new Logger(windowRollbar);
